var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentFooterSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6669 3.33309C15.2444 5.91056 15.2444 10.0894 12.6669 12.6669C10.0894 15.2444 5.91056 15.2444 3.3331 12.6669C0.755635 10.0894 0.755635 5.91056 3.3331 3.3331C5.91056 0.755635 10.0894 0.755635 12.6669 3.33309ZM13.945 13.3535C16.7779 10.2129 16.6818 5.36813 13.6569 2.34315C10.5327 -0.781049 5.46734 -0.781048 2.34315 2.34315C-0.781049 5.46734 -0.781049 10.5327 2.34315 13.6569C5.26175 16.5755 9.87442 16.7675 13.016 14.233C13.0497 14.3287 13.1048 14.4185 13.1813 14.495L17.8482 19.1619C18.1215 19.4352 18.5647 19.4352 18.8381 19.1619C19.1115 18.8885 19.1115 18.4453 18.8381 18.1719L14.1712 13.505C14.1043 13.4381 14.0273 13.3876 13.945 13.3535Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentFooterSearch);
export default __webpack_public_path__ + "static/media/comment_footer_search.c45097925cc70e49ebe8f12ad3d71572.svg";
export { ForwardRef as ReactComponent };